import { Email } from '@clearkit/icons';

import { PageLayout } from '~/components/PageLayout';
import { UserNotificationSettings } from '~/components/profile/NotificationSettings';

export const PageGeneralNotifications = () => (
  <PageLayout>
    <PageLayout.Header>
      <PageLayout.Tile>
        <Email />
      </PageLayout.Tile>
      <PageLayout.Heading>Email & Notifications</PageLayout.Heading>
      <PageLayout.SubHeading>Manage your notifications</PageLayout.SubHeading>
    </PageLayout.Header>
    <PageLayout.Body>
      <PageLayout.Content>
        <UserNotificationSettings />
      </PageLayout.Content>
    </PageLayout.Body>
  </PageLayout>
);
